const AUTH_CONFIG = {
  domain: AUTH_DOMAIN.trim(),
  clientId: AUTH_CLIENT_ID.trim(),
  callbackUrl: AUTH_CALLBACK.trim(),
  apiIdentifier: API_IDENTIFIER.trim(),
  logoutReturnUrl: LOGOUT_RETURN_URL.trim()
};

export default AUTH_CONFIG;
